export default __webpack_public_path__ + "static/media/slide10.c511aa27.png";